<div class="add-person">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <ng-container *ngIf="role === rolesEnum.CounterParty && !isCompanyDriver">
            <cyno-field>
                <cyno-label>Wie is de tegenpartij?</cyno-label>
                <input
                    cynoInput
                    formControlName="tegenpartij"
                    id="gegevens-tegenpartij-persoon"
                    type="radio"
                    class="radio"
                    value="NP"
                />
                <label for="gegevens-tegenpartij-persoon">Persoon</label>

                <input
                    cynoInput
                    formControlName="tegenpartij"
                    id="gegevens-tegenpartij-bedrijf"
                    type="radio"
                    class="radio"
                    value="NNP"
                />
                <label for="gegevens-tegenpartij-bedrijf">Bedrijf</label>
            </cyno-field>
        </ng-container>

        <ng-container *ngIf="showCompany && !isCompanyDriver">
            <cyno-field>
                <cyno-label>Handelsnaam</cyno-label>
                <input cynoInput formControlName="handelsnaam" type="text" />
                <cyno-error *ngIf="tradeName.touched && tradeName.invalid">Vul een handelsnaam in.</cyno-error>
            </cyno-field>
        </ng-container>

        <ng-container *ngIf="showPerson">
            <cyno-field>
                <cyno-label>Aanhef</cyno-label>
                <input
                    cynoInput
                    formControlName="geslacht_code"
                    id="gender-male"
                    class="radio"
                    type="radio"
                    value="M"
                />
                <label for="gender-male">Dhr.</label>

                <input
                    cynoInput
                    formControlName="geslacht_code"
                    id="gender-female"
                    class="radio"
                    type="radio"
                    value="V"
                />
                <label for="gender-female">Mevr.</label>
            </cyno-field>

            <cyno-field>
                <cyno-label>Voorletters</cyno-label>
                <cyno-initials formControlName="voorletters"></cyno-initials>
                <cyno-error *ngIf="initials.touched && initials.invalid">Vul uw voorletters in.</cyno-error>
            </cyno-field>

            <cyno-field>
                <cyno-label>Tussenvoegsel</cyno-label>
                <input cynoInput formControlName="tussenvoegsels" placeholder="Optioneel" type="text" />
            </cyno-field>

            <cyno-field>
                <cyno-label>Achternaam</cyno-label>
                <input cynoInput formControlName="achternaam" type="text" />
                <cyno-error *ngIf="lastName.touched && lastName.invalid">Vul uw achternaam in.</cyno-error>
            </cyno-field>
        </ng-container>

        <hr />

        <div class="add-person__group">
            <h4 class="add-person__label">
                Contactgegevens
                <ins-involved-role [role]="role"></ins-involved-role>
            </h4>
            <div class="add-person__group-content">
                <div class="add-person__content-label">
                    <!-- prettier-ignore -->
                    <p>
                        Welke contactgegevens heeft u van de
                        <ins-involved-role [role]="role"></ins-involved-role>?
                    </p>
                </div>

                <div class="add-person__inputs">
                    <div class="add-person__checkbox">
                        <input (change)="onToggleEmail()" id="show-email" type="checkbox" value="show" />
                        <label for="show-email">Emailadres</label>
                    </div>

                    <div *ngIf="showEmail" class="add-person__form">
                        <cyno-field class="form-group--horizontal">
                            <cyno-label>E-mailadres</cyno-label>
                            <input
                                autocomplete="username"
                                cynoInput
                                e2e="emailadres"
                                formControlName="emailadres"
                                id="emailadres"
                                inputmode="email"
                                name="emailadres"
                                type="text"
                            />
                            <cyno-error *ngIf="email.touched && email.hasError('required')">
                                Vult u uw e-mailadres nog even in?
                            </cyno-error>
                            <cyno-error *ngIf="email.touched && email.hasError('email')">
                                Helaas, dit is geen geldig e-mailadres
                            </cyno-error>
                        </cyno-field>
                    </div>

                    <div class="add-person__checkbox">
                        <input (change)="onTogglePhone()" id="show-phone" type="checkbox" value="show" />
                        <label for="show-phone">Telefoonnummer</label>
                    </div>

                    <div *ngIf="showPhone" class="add-person__form">
                        <cyno-field class="form-group--horizontal">
                            <cyno-label>Telefoonnummer</cyno-label>
                            <cyno-phone formControlName="telefoonnummer" placeholder="0123456789"></cyno-phone>
                            <cyno-error *ngIf="phoneNumber.touched && phoneNumber.invalid">
                                Vul uw telefoonnummer in.
                            </cyno-error>
                        </cyno-field>
                    </div>

                    <div class="add-person__checkbox">
                        <input (change)="onToggleAddress()" id="show_adres" type="checkbox" value="show" />
                        <label for="show_adres">Adres</label>
                    </div>

                    <!--Address start-->
                    <div *ngIf="showAddress" class="add-person__form">
                        <cyno-field class="form-group form-group--horizontal">
                            <cyno-label>Land</cyno-label>
                            <select cynoSelect formControlName="country_id">
                                <option *ngFor="let land of countries" value="{{ land.country_id }}">
                                    {{ land.country_description }}
                                </option>
                            </select>
                        </cyno-field>

                        <!-- Nederland -->
                        <ng-container *ngIf="!isForeignCountry">
                            <cyno-field class="form-group--horizontal">
                                <cyno-label>Postcode</cyno-label>
                                <cyno-postcode
                                    (changed)="onChangeAddress()"
                                    formControlName="postcode"
                                    placeholder="1234AB"
                                ></cyno-postcode>
                            </cyno-field>

                            <cyno-field class="form-group--horizontal">
                                <cyno-label>Huisnummer</cyno-label>
                                <input
                                    (ngModelChange)="onChangeAddress()"
                                    class="form-control--static-small"
                                    cynoInput
                                    formControlName="huisnummer"
                                    type="number"
                                />
                            </cyno-field>

                            <cyno-field class="form-group--horizontal">
                                <cyno-label>Toevoeging</cyno-label>
                                <input
                                    class="form-control--static-small"
                                    cynoInput
                                    formControlName="toevoeging"
                                    type="text"
                                />
                            </cyno-field>

                            <div *ngIf="hasAddressError" class="form-control-validation">
                                <div class="alert alert--validation alert--center">
                                    <div class="alert__icon">
                                        <wuc-icon-ui type="primary" icon="cross-closed"></wuc-icon-ui>
                                    </div>
                                    Helaas! Deze combinatie van postcode en huisnummer bestaat niet.
                                </div>
                            </div>

                            <div *ngIf="!!cityStreet" class="form-group--horizontal">
                                <div class="control-input">{{ cityStreet.street_name }}, {{ cityStreet.city }}</div>
                            </div>
                        </ng-container>

                        <!--Foreign-->
                        <ng-container *ngIf="isForeignCountry">
                            <cyno-field class="form-group--horizontal">
                                <cyno-label>Postcode</cyno-label>
                                <input cynoInput formControlName="postcode" type="text" />
                            </cyno-field>

                            <cyno-field class="form-group--horizontal">
                                <cyno-label>Huisnummer</cyno-label>
                                <input
                                    class="form-control--static-small"
                                    cynoInput
                                    formControlName="huisnummer"
                                    type="number"
                                />
                                <input
                                    class="form-control--static-small"
                                    cynoInput
                                    formControlName="toevoeging"
                                    type="text"
                                />
                            </cyno-field>

                            <div *ngIf="hasAddressError" class="form-control-validation">
                                <div class="alert alert--validation alert--center">
                                    <div class="alert__icon">
                                        <wuc-icon-ui type="primary" icon="cross-closed"></wuc-icon-ui>
                                    </div>
                                    Helaas! Deze combinatie van postcode en huisnummer bestaat niet.
                                </div>
                            </div>

                            <cyno-field class="form-group--horizontal">
                                <cyno-label>Straat</cyno-label>
                                <input cynoInput formControlName="straatnaam" type="text" />
                            </cyno-field>

                            <cyno-field class="form-group--horizontal">
                                <cyno-label>Woonplaats</cyno-label>
                                <input cynoInput formControlName="woonplaats" type="text" />
                            </cyno-field>
                        </ng-container>
                        <!-- Einde adres -->
                    </div>

                    <div *ngIf="showInfo" class="add-person__checkbox">
                        <input (change)="onToggleInfoText()" id="geen_contactgegevens" type="checkbox" value="show" />
                        <label for="geen_contactgegevens">Ik heb geen contactgegevens</label>
                    </div>
                    <div *ngIf="showInfoText" class="add-person__checkbox add-person__checkbox--whitespace-initial">
                        <p>
                            <svg class="svg-icon svg-icon--s">
                                <use href="assets/icons-ui.svg#informatie"></use>
                            </svg>
                            Zonder contactgegevens kunnen wij deze betrokkene helaas niet gebruiken bij de behandeling
                            van de schade.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <cyno-alert
            *ngIf="notifications"
            [customClass]="'alert-error--invert'"
            [meldingen]="notifications"
        ></cyno-alert>

        <div class="form-group button-group">
            <div class="control-label">
                <a (click)="onCancel()" class="btn btn--prev" href="#" tabindex="-1">
                    <svg class="svg-icon svg-icon--xs">
                        <use href="assets/icons-ui.svg#pijl-left-bold"></use>
                    </svg>
                    Annuleren
                </a>
            </div>
            <div *ngIf="showAddress || showPhone || showEmail || showCompany" class="control-input">
                <button
                    [disabled]="form.invalid || (showAddress && !hasAddressSuccess && !isForeignCountry)"
                    class="btn btn--primary btn--block"
                    type="submit"
                >
                    Toevoegen
                </button>
            </div>
        </div>
    </form>
</div>
